'use strict';

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Badge from "react-bootstrap/Badge";

import {pluralize} from "@uw-it-sis/lib-react/lib/Utils";

/**
 * Create a react bootstrap badge with the credit value passed
 */
const CreditBadge = ({credit, variant = "light-gray", className}) => {
    if ( credit && credit !== "" ) {
        let styleClasses = classnames(
            "text-dark align-middle fs-9 text-uppercase fw-normal border",
            {[className]: className !== ""}
        );

        let helpText = `${credit} ${pluralize("Credit", credit)}`;

        return (
            <>
                <Badge bg={variant}
                       className={styleClasses}
                       aria-hidden={true}>
                    <abbr title={helpText}>{credit} CR</abbr>
                </Badge>
                <span className="sr-only">{helpText}</span>
            </>
        )
    } else {
        return null;
    }
}

CreditBadge.propTypes = {
    credit: PropTypes.string.isRequired,
    variant: PropTypes.string,
    className: PropTypes.string
};

export default CreditBadge;